const renderElem = ({ tagName, attrs = {}, on = {}, children = [] }) => {
  // create the element
  //   e.g. <div></div>
  const $el = document.createElement(tagName);

  // add all attributs as specified in vNode.attrs
  //   e.g. <div id="app"></div>
  for (const [k, v] of Object.entries(attrs)) {

    if(k === 'class') {
      $el.setAttribute(k, v.join(' '));
      continue;
    }

    $el.setAttribute(k, v);
  }

  // append all children as specified in vNode.children
  //   e.g. <div id="app"><img></div>
  for (const child of children) {
    $el.appendChild(render(child));
  }

  // JS events handler
  for(const [event, handler] of Object.entries(on)) {
    $el.addEventListener(event, handler);
  }

  return $el;
};

const renderComponent = (vComponent) => {

  console.log(vComponent);
  // vComponent.computeVNode();
  vComponent.isMounted = true;
  vComponent.rootNode = renderElem(vComponent.vNode);
  return vComponent.rootNode
};

const render = vNode => {
  if (typeof vNode === 'string') {
    return document.createTextNode(vNode);
  }

  if(vNode.name) {
    return renderComponent(vNode);
  }

  // we assume everything else to be a virtual element
  return renderElem(vNode);
};

export default render;
